import React, { useState, useEffect, useContext } from "react";
import { nextDocument } from "react-doc-viewer/build/state/actions";
import {Link, NavLink, useHistory} from 'react-router-dom';
import { Button } from 'reactstrap';
import EventContext from "../../contexts/event";
import SocketClient from '../../helpers/connection';
import {useIntl} from "react-intl";
import {useApolloClient} from "@apollo/client";
import ButtonTooltip from "../button-tooltip";
import {syncQuizModeratorAction, QuizModeratorActionPayload} from "../../helpers/sync-quiz-moderator-action";


//control panel for handeling the quiz
const QuizControls: React.FC<{
  usersLength: number;
  presentationId?: string;
  answersLength: number;
  setStartTimer?: (arg0: boolean) => void;
  setResultPage?: (arg0: boolean) => void;
  mimicFormButtonClick?: () => void;
  nextQuestion?: () => void;
  answerId: string;
  noNext?: boolean;
  nextDisabled?: boolean;
  podiumDisabled?: boolean;
  podium?: boolean;
  onBack?: boolean;
  questionIndex?: number;
}> = ({ usersLength, answersLength, setResultPage, setStartTimer, presentationId, answerId, mimicFormButtonClick, nextQuestion, noNext = false, nextDisabled = false, podiumDisabled = false, onBack = false, podium = true,questionIndex=0 }) => {


  const eventContext = useContext(EventContext);
    const history = useHistory();
    const intl = useIntl();
    const apolloClient = useApolloClient();

    function updateAction(jsonData: {
        presentationId?: string;
        action: string;
        question_index: number;
    }) {
        const targetPresentationId = jsonData.presentationId || presentationId;
        if (!targetPresentationId) {
            return;
        }

        syncQuizModeratorAction(apolloClient, {
            presentationId: targetPresentationId,
            action: jsonData.action,
            question_index: jsonData.question_index,
        })
            .then((response) => {
                console.log("updateAction response", response);
            })
            .catch((error) => {
                console.log("updateAction error", error);
            });
    }



  return (
    <div className="quiz-controls">
      <div className="connected-users-answers">

          <div className="common"><span>{usersLength}</span> {intl.formatMessage({ id: "quiz.connected" })}</div>
          <div className="seperator"></div>
          <div className="common"><span>{answersLength}</span> {intl.formatMessage({ id: "quiz.answers" })}</div>

      </div>
      <div className="controls">
        {
          onBack && <Button   onClick={()=>{


                history.push(
                    `/${eventContext.slug}/${presentationId}/quiz-questions`,{'data':'back_press'}
                )

          }}  className="btn btn-next">{intl.formatMessage({ id: "button.common.back" })} </Button>
        }
        {
          setStartTimer && <ButtonTooltip id="quiz-stop-timer" messageId="quiz.tooltip.stop_timer">
            <Button onClick={() => {
            //socket.emit("action","timer_stop");
                updateAction({
                    action: "timer_stop",
                    question_index: questionIndex
                });
                //SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:timer_stop"}`);
             setStartTimer(false);
            }
            } className="stop-timer"><img src="/icons/stop-timer-ico.svg" alt="" /></Button>
          </ButtonTooltip>
        }
        {
          setStartTimer && <ButtonTooltip id="quiz-start-timer" messageId="quiz.tooltip.start_timer">
            <Button onClick={() =>{

                updateAction( {
                    presentationId: presentationId,
                    action: "timer_start",
                    question_index:questionIndex
                    }
                );

             setStartTimer(true);
            }} className="start-timer"><img src="/icons/start-timer-ico.svg" alt="" /></Button>
          </ButtonTooltip>
        }
        {
          mimicFormButtonClick && <Button className="stop-timer" onClick={() => mimicFormButtonClick()} >Submit</Button>
        }
        {
          podium && <ButtonTooltip id="quiz-podium" messageId="quiz.tooltip.podium">
            <Button disabled={podiumDisabled} className={`btn ${podiumDisabled ? 'noHover' : ''}`}   onClick={()=>{

                updateAction( {
                    presentationId: presentationId,
                        action: "show_podium",
                        question_index:questionIndex
                    }
                );
                console.log("PAGE INDEX",questionIndex);
                SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:show_podium"}`);
                history.push(
                    `/${eventContext.slug}/${presentationId}/podium/${answerId}`,{'index':questionIndex+1}
                )

           // socket.emit("action","show_podium");
          }}><img src="/icons/podium-ico.svg" alt="" />Podium</Button>
          </ButtonTooltip>
        }
        {
          podium && <ButtonTooltip id="quiz-results" messageId="quiz.tooltip.results">
            <Button disabled={podiumDisabled} activeClassName="selected" className="btn" onClick={() => {
            if (setResultPage) {
                updateAction( {
                    presentationId: presentationId,
                    action: "show_result",
                    question_index:questionIndex
                    }
                );
                //SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:show_result"}`);
               // socket.emit("action","show_result");
              // show result action
              setResultPage(true)

            }
          }}><img src="/icons/results-ico.svg" alt="" />{intl.formatMessage({ id: "quiz.results.msg" })}</Button>
          </ButtonTooltip>
        }
        {
          !noNext && <ButtonTooltip id="quiz-next" messageId="quiz.tooltip.next">
            <Button disabled={nextDisabled} onClick={() => {

            if (setResultPage) {
              // hide result action
              setResultPage(false)
            }
            if (nextQuestion) {
                localStorage.setItem('answered_users', '0');
                updateAction( {
                    presentationId: presentationId,
                    action: "next_question",
                    question_index:questionIndex+1
                });
                //SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:next_question"}`);
              nextQuestion?.();
            }
          }} className={`btn ${nextDisabled ? 'noHover' : ''}  btn-next`}>{intl.formatMessage({ id: "quiz.next" })} <img src="/icons/quiz-next-ico.svg" alt="" /></Button>
          </ButtonTooltip>
        }

      </div>
    </div>
  )
}

export default QuizControls;


